import { useEffect, useRef } from "react";

import activeCampaign from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-activecampaign.webp.asset.json";
import advbox from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-advbox.webp.asset.json";
import agendor from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-agendor.webp.asset.json";
import asaas from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-asaas.webp.asset.json";
import autentique from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-autentique.webp.asset.json";
import bagy from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-bagy.webp.asset.json";
import belasis from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-belasis.webp.asset.json";
import braip from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-braip.webp.asset.json";
import cakto from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-cakto.webp.asset.json";
import clicksign from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-clicksign.webp.asset.json";
import clinicorp from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-clinicorp.webp.asset.json";
import guru from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-digital-manager-guru.webp.asset.json";
import docusign from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-docusign.webp.asset.json";
import eduzz from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-eduzz.webp.asset.json";
import elementor from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-elementor.webp.asset.json";
import escavador from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-escavador.webp.asset.json";
import feegow from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-feegow.webp.asset.json";
import googleForms from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-google-forms-e-sheets.webp.asset.json";
import greenn from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-greenn.webp.asset.json";
import hotmart from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-hotmart.webp.asset.json";
import hubla from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-hubla.webp.asset.json";
import hubspot from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-hubspot.webp.asset.json";
import kirvano from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-kirvano.webp.asset.json";
import kiwify from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-kiwify.webp.asset.json";
import lastlink from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-lastlink.webp.asset.json";
import linkedin from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-linkedin-lead-gen.webp.asset.json";
import lojaIntegrada from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-loja-integrada.webp.asset.json";
import mobiauto from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-mobiauto.webp.asset.json";
import monetizze from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-monetizze.webp.asset.json";
import mercadoPago from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-mercado-pago.webp.asset.json";
import olx from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-olx.webp.asset.json";
import omie from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-omie.webp.asset.json";
import payt from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-payt.webp.asset.json";
import perfectPay from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-perfect-pay.webp.asset.json";
import pipedrive from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-pipedrive.webp.asset.json";
import rdStation from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-rd-station.webp.asset.json";
import respondi from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-respondi.webp.asset.json";
import shopify from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-shopify.webp.asset.json";
import stripe from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-stripe.webp.asset.json";
import ticto from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-ticto.webp.asset.json";
import typeform from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-typeform.webp.asset.json";
import vega from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-vega-checkout.webp.asset.json";
import webmotors from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-webmotors.webp.asset.json";
import woocommerce from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-woocommerce.webp.asset.json";
import yampi from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-yampi.webp.asset.json";
import zapImoveis from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-zap-imoveis-vivareal.webp.asset.json";
import zapsign from "@/assets/integracoes/OP2P-CRM-e-Agentes-de-IA-integracao-zapsign.webp.asset.json";

export const integrations = [
  { name: "HubSpot", logo: hubspot.url }, { name: "Shopify", logo: shopify.url },
  { name: "Clicksign", logo: clicksign.url }, { name: "Hotmart", logo: hotmart.url },
  { name: "Pipedrive", logo: pipedrive.url }, { name: "Google Forms e Sheets", logo: googleForms.url },
  { name: "RD Station", logo: rdStation.url }, { name: "WooCommerce", logo: woocommerce.url },
  { name: "Agendor", logo: agendor.url }, { name: "DocuSign", logo: docusign.url },
  { name: "Kiwify", logo: kiwify.url }, { name: "Webmotors", logo: webmotors.url },
  { name: "ActiveCampaign", logo: activeCampaign.url }, { name: "Omie", logo: omie.url },
  { name: "Typeform", logo: typeform.url }, { name: "OLX", logo: olx.url },
  { name: "Autentique", logo: autentique.url }, { name: "Eduzz", logo: eduzz.url },
  { name: "Loja Integrada", logo: lojaIntegrada.url }, { name: "Perfect Pay", logo: perfectPay.url },
  { name: "LinkedIn Lead Gen", logo: linkedin.url }, { name: "Stripe", logo: stripe.url },
  { name: "Feegow", logo: feegow.url }, { name: "Yampi", logo: yampi.url },
  { name: "Bagy", logo: bagy.url }, { name: "ZapSign", logo: zapsign.url },
  { name: "ADVBOX", logo: advbox.url }, { name: "Monetizze", logo: monetizze.url },
  { name: "Elementor", logo: elementor.url }, { name: "Cakto", logo: cakto.url },
  { name: "Mobiauto", logo: mobiauto.url }, { name: "Braip", logo: braip.url },
  { name: "Vega Checkout", logo: vega.url }, { name: "Clinicorp", logo: clinicorp.url },
  { name: "Greenn", logo: greenn.url }, { name: "Lastlink", logo: lastlink.url },
  { name: "ZAP Imóveis + VivaReal", logo: zapImoveis.url }, { name: "Kirvano", logo: kirvano.url },
  { name: "Digital Manager Guru", logo: guru.url }, { name: "Ticto", logo: ticto.url },
  { name: "Respondi", logo: respondi.url }, { name: "Payt", logo: payt.url },
  { name: "Belasis", logo: belasis.url }, { name: "Escavador", logo: escavador.url },
  { name: "Hubla", logo: hubla.url },
  { name: "Asaas", logo: asaas.url }, { name: "Mercado Pago", logo: mercadoPago.url },
];

export function IntegrationMarquee() {
  const trackRef = useRef<HTMLDivElement>(null);
  const offsetRef = useRef(0);
  const draggingRef = useRef(false);
  const pointerXRef = useRef(0);
  const velocityRef = useRef(0);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let frame = 0;
    let previous = performance.now();

    const animate = (now: number) => {
      const delta = Math.min(now - previous, 40);
      previous = now;
      const loopWidth = track.scrollWidth / 2;

      if (!draggingRef.current && loopWidth > 0) {
        const baseSpeed = reduceMotion ? 0 : 0.034;
        offsetRef.current += velocityRef.current - baseSpeed * delta;
        velocityRef.current *= 0.96;
      }

      if (loopWidth > 0) {
        while (offsetRef.current <= -loopWidth) offsetRef.current += loopWidth;
        while (offsetRef.current > 0) offsetRef.current -= loopWidth;
      }
      track.style.transform = `translate3d(${offsetRef.current}px, 0, 0)`;
      frame = requestAnimationFrame(animate);
    };

    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, []);

  const onPointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
    draggingRef.current = true;
    pointerXRef.current = event.clientX;
    velocityRef.current = 0;
    event.currentTarget.setPointerCapture(event.pointerId);
  };

  const onPointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
    if (!draggingRef.current) return;
    const movement = event.clientX - pointerXRef.current;
    pointerXRef.current = event.clientX;
    offsetRef.current += movement;
    velocityRef.current = movement * 0.6;
  };

  const releasePointer = (event: React.PointerEvent<HTMLDivElement>) => {
    draggingRef.current = false;
    if (event.currentTarget.hasPointerCapture(event.pointerId)) {
      event.currentTarget.releasePointerCapture(event.pointerId);
    }
  };

  return (
    <div className="integration-strip">
      <p className="integration-strip__label">Integre a OP2P CRM com o que você quiser:</p>
      <div
        className="integration-strip__viewport"
        aria-label="Integrações disponíveis. Arraste para explorar."
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={releasePointer}
        onPointerCancel={releasePointer}
      >
        <div ref={trackRef} className="integration-strip__track">
          {[0, 1].map((copy) => (
            <div className="integration-strip__set" key={copy} aria-hidden={copy === 1}>
              {integrations.map((integration) => (
                <span className="integration-strip__item" key={`${copy}-${integration.name}`}>
                  <img
                    src={integration.logo}
                    alt={copy === 0 ? `Logotipo ${integration.name}, integração com a OP2P` : ""}
                    width="26"
                    height="26"
                    loading="lazy"
                    draggable="false"
                  />
                  <span>{integration.name}</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}